import './update-rating-compliance-rule.scss'

import { notification } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, InputNumber, SubmitButton } from 'formik-antd'
import React, { useEffect, useState } from 'react'
import { Column } from 'react-display-flex'

import { convertEntityValuesToFormValues } from '../../../../../util/convert-entity-values-to-form-values'
import { httpClient } from '../../../../../util/http-client'
import { RatingComplianceRule } from '../models'
import { ratingCompliancesRulesMessages } from './messages'
import { updateRatingComplianceRuleValues } from './models'
import { ratingComplianceRuleValidationSchema } from './validators'

interface UpdateRatingComplianceProps {
  groupId: number
  domain: string
  ratingComplianceRule: RatingComplianceRule
  onSuccess?: () => void
}

export const UpdateIssuerCompliance = ({
  groupId,
  domain,
  ratingComplianceRule,
  onSuccess,
}: UpdateRatingComplianceProps) => {
  const [tradeFormValues, setTradeFormValues] = useState(updateRatingComplianceRuleValues)

  useEffect(() => {
    if (!ratingComplianceRule) return
    setTradeFormValues(convertEntityValuesToFormValues(updateRatingComplianceRuleValues, ratingComplianceRule))
  }, [ratingComplianceRule])

  const onSubmit = async (formData) => {
    try {
      await httpClient(`/compliances/ratings/groups/${groupId}/rules/${ratingComplianceRule?.id}`, {
        method: 'PUT',
        domain,
        data: formData,
      })
      notification.success({
        message: ratingCompliancesRulesMessages.common.success,
        description: ratingCompliancesRulesMessages.update.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: ratingCompliancesRulesMessages.common.error,
        description: ratingCompliancesRulesMessages.update.error,
      })
    }
  }

  return (
    <Formik
      initialValues={tradeFormValues}
      validationSchema={ratingComplianceRuleValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="update-rating-compliance-rule">
        <FormItem name="maxLimit" label="Max Limit" required>
          <InputNumber name="maxLimit" />
        </FormItem>
        <FormItem name="ratingType" label="Rating Type" required>
          <Input name="ratingType" />
        </FormItem>
        <FormItem name="rating" label="Rating" required>
          <Input name="rating" />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
